<template>
  <div>
    <b-card :title="$t('Setting')">
      <b-row class="mb-1">
        <b-col md="6">
          <b-form-group
            :label="$t('Point')"
            label-for="Point"
          >
            <cleave
              id="point"
              v-model="point"
              class="form-control"
              :raw="false"
              :options="optionCleave.number"
              :placeholder="$t('Enter point')"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            :label="$t('Amount')"
            label-for="Amount"
          >
            <cleave
              id="amount"
              v-model="amount"
              class="form-control"
              :raw="false"
              :options="optionCleave.number"
              :placeholder="$t('Enter amount')"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-button
        variant="primary"
        class="mr-2"
        @click="saveChanged"
      >
        {{ $t('Save Changes') }}
      </b-button>
      <b-button
        class="mr-2"
      >
        {{ $t('Discard') }}
      </b-button>
    </b-card>
  </div>
</template>

<script>
import {
  BTabs,
  BTab,
  BCard,
  BRow,
  BCol,
  BImg,
  BAvatar,
  BFormInput,
  BButton,
  BTable,
  BPagination,
  BDropdown,
  BOverlay,
  BCardText,
  BDropdownItem,
  BFormGroup,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import perPageOptions from '@/perPageOptions'
// import { useToast } from 'vue-toastification/composition'
import Cleave from 'vue-cleave-component'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

// import { ref } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'

const STORE_MODULE_NAME = 'mlm'

export default {
  components: {
    BTabs,
    BTab,
    BCard,
    BRow,
    BCol,
    // eslint-disable-next-line vue/no-unused-components
    BImg,
    // eslint-disable-next-line vue/no-unused-components
    BAvatar,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BDropdown,
    BDropdownItem,
    BOverlay,
    BCardText,
    BFormGroup,
    Cleave,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      avatarText,
      optionCleave: {
        number: {
          numeral: true,
        },
      },
      point: 1,
      amount: 100,
      perPageOptions,
    }
  },
  computed: {
    settings() {
      return store.state[STORE_MODULE_NAME].respData != null ? store.state[STORE_MODULE_NAME].respData.settings : {
        point: 0,
        amount: 0,
      }
    },
  },
  watch: {
    settings: {
      handler(newValue, oldValue) {
        // console.log('oldValue has changed:', oldValue)
        // console.log('newValue has changed:', newValue)
        if (newValue) {
          this.point = newValue.point
          this.amount = newValue.amount
        }
      },
      deep: true, // ใช้ deep เพื่อติดตามการเปลี่ยนแปลงในระดับลึก
    },
  },
  mounted() {
    if (this.settings) {
      this.point = this.settings.point
      this.amount = this.settings.amount
    }
  },
  methods: {
    saveChanged() {
      this.show = true
      store
        .dispatch(`${STORE_MODULE_NAME}/settings`, {
          settings: {
            point: this.point.toString().replaceAll(',', ''),
            amount: this.amount.toString().replaceAll(',', ''),
          },
        })
      // eslint-disable-next-line no-unused-vars
        .then(result => {
          this.show = false
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Success'),
              icon: 'SuccessIcon',
              variant: 'success',
              text: this.$t(result.data.message),
            },
          })
          // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
        })
        .catch(error => {
          this.show = false
          console.log('fetchUsers Error : ', error)
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
  },
}
</script>

  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';

  .v-select-custom {
    display: inline-block;
    width: 50;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .b-col-custom {
    margin-top: 0.5rem;
  }
  </style>
